import React from 'react'
import { Link } from 'gatsby'

const Profile = props => {
  return (
    <div className="col-lg-3 col-sm-6 g-mb-30">
      {/* Team Block */}
      <div className="u-info-v1-2">
        {/* Figure */}
        <figure className="u-block-hover">
          {/* Figure Image */}
          <img className="w-100" src={props.image} alt={props.name} />
          {/* End Figure Image*/}
          {/* Figure Caption */}
          <figcaption className="u-block-hover__additional--fade g-bg-primary-opacity-0_9 g-pa-30">
            <div className="u-block-hover__additional--fade u-block-hover__additional--fade-down g-flex-middle">
              {/* Figure Social Icons */}
              <ul className="list-inline text-center g-flex-middle-item">
                <li className="list-inline-item align-middle g-mx-3">
                  <a className="u-icon-v2 u-icon-size--sm g-font-size-default g-color-white g-color-primary--hover g-brd-white g-bg-white rounded-circle" href={props.linkedin}>
                    <i className="fa fa-linkedin" />
                  </a>
                </li>
              </ul>
              {/* End Figure Social Icons */}
            </div>
          </figcaption>
          {/* End Figure Caption */}
        </figure>
        {/* End Figure */}
        {/* Figure Info */}
        <div className="g-bg-white g-py-25">
          <div className="g-mb-15">
            <h4 className="h5 g-color-black g-mb-5">{props.name}</h4>
            <em className="d-block u-info-v1-2__item g-font-style-normal g-font-size-11 text-uppercase g-color-primary">{props.title}</em>
          </div>
          <div>
            {props.children}
          </div>
        </div>
        {/* End Figure Info*/}
      </div>
      {/* End Team Block */}
    </div>
  )
}

export default Profile